import { pipe } from '@wiko/functional';
import { parseJsonWithBigInts, stringifyJsonWithBigints } from '@wiko/rpc-spec-types';
import {
    RpcSubscriptionsChannel,
    transformChannelInboundMessages,
    transformChannelOutboundMessages,
} from '@wiko/rpc-subscriptions-spec';

export function getRpcSubscriptionsChannelWithBigIntJSONSerialization(
    channel: RpcSubscriptionsChannel<string, string>,
): RpcSubscriptionsChannel<unknown, unknown> {
    return pipe(
        channel,
        c => transformChannelInboundMessages(c, parseJsonWithBigInts),
        c => transformChannelOutboundMessages(c, stringifyJsonWithBigints),
    );
}
